<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">就医服务投诉管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          就医服务投诉管理系统是一套以数字化手段采集患者诉求、规范处置流程、驱动服务改进的管理工具。系统覆盖投诉、建议、咨询、表扬四类诉求，贯通用户端、管理端及系统管理端，构建 “诉求采集 - 工单处置 - 分析改进” 的闭环体系，为医院提升服务质量提供数据支撑。
        </p>
        <p class="content-paragraph">
          在业务层面，系统支持投诉上报、受理、情况核实、第三方处理流程信息录入、反馈、改进措施、补录与关联的全流程管理，同时承载建议采集与采纳、咨询问题采集与反馈、表扬情况采集与反馈；在管理层面，提供就医服务大屏展示、业务精细化分析与业务报告自动生成能力，实现诉求可追溯、改进可量化。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">投诉管理</h3>
            <ul class="capability-list"><li>投诉上报</li><li>投诉受理</li><li>情况核实</li><li>第三方处理流程信息录入</li><li>投诉反馈</li><li>改进措施</li><li>投诉补录</li><li>投诉关联</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">建议 · 咨询 · 表扬</h3>
            <ul class="capability-list"><li>建议采集</li><li>建议采纳</li><li>建议反馈</li><li>咨询问题采集</li><li>咨询问题反馈</li><li>咨询答案维护</li><li>表扬情况采集</li><li>表扬情况反馈</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">分析与展示</h3>
            <ul class="capability-list"><li>实时工单及报告展示</li><li>投诉相关趋势分析</li><li>表扬工单趋势分析</li><li>投诉分析</li><li>建议分析</li><li>咨询分析</li><li>表扬分析</li><li>报告生成管理</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ts-report.svg"
              alt="海南华德科技有限公司 就医服务投诉管理系统 - 投诉上报 · 扫码即提"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>投诉上报 · 扫码即提
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ts-workflow.svg"
              alt="海南华德科技有限公司 就医服务投诉管理系统 - 工单处置 · 受理到改进闭环"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>工单处置 · 受理到改进闭环
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ts-screen.svg"
              alt="海南华德科技有限公司 就医服务投诉管理系统 - 就医服务大屏 · 实时工单与趋势"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>就医服务大屏 · 实时工单与趋势
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ts-reportgen.svg"
              alt="海南华德科技有限公司 就医服务投诉管理系统 - 业务报告自动生成"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>业务报告自动生成
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/software11.vue